<template>
  <!-- 展览详情 -->
  <div class="page-exbition-detail">
    <div class="pic-box1">
      <img v-lazy="detail.spMain" alt="" />
    </div>
    <div class="g-banner">
      <div class="exhibit">
        <div class="flex-box">
          <h1 class="name">{{ detail.name }}</h1>
        </div>
      </div>

      <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
    </div>

    <div class="g-content-wrap" style="min-height: 300px;">
      <div class="des-box" v-if="activeVal == 1">
        <p v-html="detail.des"></p>
      </div>

      <div v-if="activeVal == 2">
        <div class="masonry-container" v-masonry transition-duration="0" item-selector=".item" :gutter="gutter">
          <div v-masonry-tile class="item" :class="{'min': gutter<25}" v-for="(item, index) in wwData" :key="index">
            <div class="pic-box2">
              <img v-lazy="item" alt="" />
            </div>
          </div>

          <!-- 无数据 -->
          <div class="g-no-data" v-if="wwData.length === 0 && !listLoading">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import cmpTab from '@cmp/tab'
import player1 from '@cmp/video-player'
import { VueMasonryPlugin } from 'vue-masonry'
Vue.use(VueMasonryPlugin)
export default {
  components: { cmpTab, player1 },
  data() {
    return {
      detailId: this.$route.query.id,
      detail: {},
      wwData: [],
      gutter: 25,

      hotVideo: [],
      videoUrl: '',
      videoId: '',
      title: '',
      detialPlayVideo: false,
      activeVal: '1',
      tabList: [
        {
          name: '项目简介',
          val: '1'
        },
        {
          name: '项目风采',
          val: '2'
        },
      ]
    }
  },
  methods: {
    getDetailData() {
      this.$http
        .get('../singleMuseum/applet/volunteer/groupDetail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detail = res.result
            if (res.result.pics) {
              this.wwData = res.result.pics.split(';')
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    playVideo(item) {
      if (item.url) {
        this.detialPlayVideo = true
        this.videoId = item.id
        this.videoUrl = item.url
        this.title = item.name
      }
    },
    closePlay() {
      this.videoUrl = ''
      this.videoId = ''
      this.title = ''
      this.detialPlayVideo = false
    },
    eventTabClick(val) {
      this.activeVal = val
    }
  },
  created() {
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.page-exbition-detail {
  margin-top: 30px;
  .pic-box1 {
    width: 100%;
    height: 100%;
    background: #f6f6f6;
    text-align: center;
    img {
      width: 1600px;
      height: 896px;
      object-fit: cover;
    }
  }

  .g-banner {
    padding-top: 48px;
    background: #f6f6f6;
    /deep/.cmp-tab-wrap {
      padding: 20px 0;
      .item {
        font-size: 24px;
        font-weight: 400;
        color: #000000;
        &.active {
          border-bottom: solid 4px rgba($color: #ae8148, $alpha: 0.8);
        }
      }
    }
  }

  .exhibit {
    width: 1600px;
    margin: 0 auto;

    .flex-box {
      justify-content: space-between;
      align-items: flex-start;
      .name {
        font-size: 44px;
        font-weight: bold;
        color: #000000;
      }

      .right-box {
        img {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }
        p {
          font-size: 20px;
          font-weight: 400;
          color: #010101;
        }
      }
    }
    .address {
      margin-bottom: 33px;
    }
  }

  .g-content-wrap {
    margin-top: 72px;
    .pic-box {
      height: 288px;
    }

    .masonry-container {
      .g-card-list {
        display: initial;
      }
      .item {
        margin-bottom: 35px;
        width: 375px;
        cursor: pointer;
        &.min {
          width: 360px;
        }
        img {
          width: 100%;
        }
        .info {
          padding: 28px 40px;
          background: rgba($color: #f6f6f6, $alpha: 0.4);
          h2 {
            font-size: 24px;
            margin-bottom: 15px;
          }
          p {
            font-size: 18px;
            font-weight: 500;
            color: rgba($color: #000000, $alpha: 0.7);
          }
        }
      }
    }
  }
  .des-box {
    width: 1053px;
    p {
      text-indent: 36px;
      font-size: 18px;
      font-weight: 400;
      color: rgba($color: #000000, $alpha: 0.9);
      line-height: 32px;
    }
    /deep/img {
      width: 100%;
    }
  }

  .item {
    .info1 {
      border: 1px solid rgba(#121100, 0.2);
      border-top: none;
      padding: 23px 27px 24px 40px;
      h2 {
        font-size: 28px;
        font-weight: 400;
        color: #000000;
      }
      .time {
        margin-top: 12px;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
      }

      .intro {
        font-size: 16px;
        font-weight: 400;
        color: rgba(#000000, 0.7);
      }
    }
  }
}
</style>
